// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"354":"fe016d70","367":"9e3be1f2","652":"9989cc0f","686":"b5976bce"}[chunkId] + ".chunk.css";
};